import React from 'react';
import {Box, styled} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';

const Root = styled(Box)(() => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  gap: '24px',
  width: '100%',
  height: '100%',
  maxHeight: '100%',
  backgroundColor: designSystemToken('semantic.bg.primary'),
  overflow: 'hidden',
}));

const LeftColumn = styled(Box)(() => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
}));

const RightColumn = styled(Box)(() => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
}));

type SplitLayoutProps = {
  testID?: string;
  leftColumn: React.ReactNode;
  rightColumn: React.ReactNode;
};

function SplitLayout({
  testID = 'split-layout',
  leftColumn,
  rightColumn,
}: SplitLayoutProps) {
  return (
    <Root data-testid={testID}>
      <LeftColumn>{leftColumn}</LeftColumn>
      <RightColumn>{rightColumn}</RightColumn>
    </Root>
  );
}

export default SplitLayout;
